module.exports = __webpack_public_path__ + "static/desktopHash-e439cf4b3f2a1c6b108afe80d7164f94.png";